import { render, staticRenderFns } from "./detailPushRecord.vue?vue&type=template&id=339eb091&scoped=true&"
import script from "./detailPushRecord.vue?vue&type=script&lang=js&"
export * from "./detailPushRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339eb091",
  null
  
)

export default component.exports